export default __webpack_public_path__ + "static/media/(83).0401d2c7.jpg";